import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface PageHistoryItem {
  path: string
  data?: Record<string, any>
  timestamp: number
}

interface NavigationState {
  // State
  pageHistory: PageHistoryItem[]

  // Actions
  addPage: (path: string, data?: Record<string, any>) => void
  removeLastPage: () => PageHistoryItem | null
  clearHistory: () => void
  getLastPage: () => PageHistoryItem | null
  hasHistory: () => boolean
}

export const useNavigationStore = create<NavigationState>()(
  persist(
    (set, get) => ({
      // Initial state
      pageHistory: [],

      // Actions
      addPage: (path, data) => {
        console.log('addPage', path, data);
        set((state) => ({
          pageHistory: [
            ...state.pageHistory,
            {
              path,
              data,
              timestamp: Date.now(),
            },
          ],
        }));
      },

 

      removeLastPage: () => {
        console.log('removeLastPage');
        const { pageHistory } = get();
        if (pageHistory.length === 0) {
          return null;
        }

        const lastPage = pageHistory[pageHistory.length - 1];
        set((state) => ({
          pageHistory: state.pageHistory.slice(0, -1),
        }));

        return lastPage;
      },

      clearHistory: () => {
        set({ pageHistory: [] });
      },

      getLastPage: () => {
        const { pageHistory } = get();
        return pageHistory.length > 0 ? pageHistory[pageHistory.length - 1] : null;
      },

      hasHistory: () => {
        const { pageHistory } = get();
        console.log('hasHistory', pageHistory);
        return pageHistory.length > 0;
      },
    }),
    {
      name: 'navigation-storage',
      partialize: (state) => ({
        pageHistory: state.pageHistory,
      }),
    },
  ),
);
